import { IAppState } from '../../../AppModulesWrapper';

import { selectBetPositionClientError } from './selectBetPositionClientError';

export function selectIsBetPositionVisible(state: IAppState): boolean {
  const clientError = selectBetPositionClientError(state);

  return !clientError;
}
